import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.element.addEventListener('focusout', () => {
      // reset input field to look unvalidated
      this.element.className =
        'px-4 py-3 w-full text-base bg-white rounded-md border border-stone-300 border-opacity-50 text-stone-500 focus:border-rose-400 focus:ring-1 focus:ring-rose-400 focus:outline-none';
      // remove error message if one exists
      const e = this.element
        .closest('.text-input-container')
        .querySelector('.error-message');
      if (e) {
        e.remove();
      }
    });
  }
}
